export default "__VITE_ASSET__Zhwz0HQz__"